import { render } from "./KaratayRuhsatli.vue?vue&type=template&id=0a53e608"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__